module.exports = __webpack_public_path__ + "static/media/ic-medicine-pill.ede5dc8c.svg";